import React from "react";
import ProjectCard from "./ProjectCard";
const Project = () => {
  const projects = [
    {
      title: "Eazy-Options",
      detail:
        "This is my latest progress and in progress. Here, we trying to simplify the call and put options for the financial markets",
      live: "https://eazyoptions.com/",
      tech: "ReactJS,Django,Firebase",
    },
    {
      title: "Analysis and Implementation of X-fast-trie and Y-fast-trie",
      detail:
        "CS201 Course Project. Implemented in C++. Advanced data structures",
      git: "https://github.com/Parth-Jain-2002/2020csb1103_2020csb1101_2020csb1106_X-and-Y-fast-trie",
      tech: "DSA,Algorithms,C++",
    },
    {
      title: "Smart Home Automation",
      detail:
        "Implemented a modular Smart Home System which will enhance the safety and comfort of the users. Our system takes inputs from various sensors and makes intelligent decisions.",
      git: "https://github.com/Parth-Jain-2002/CS203_Project_2020CSB1106_2020CSB1114",
      tech: "Verilog",
    },
    {
      title: "Multiplayer Rock-Paper-Scissors",
      detail:
        "In childhood, we used to play rock-paper-scissors with joy. So implemented rock-paper-scissor game using socket.io . Do give this game a try and play it with your friends.",
      git: "https://github.com/Parth-Jain-2002/Multiplayer-RPS",
      live: "https://multiplayerrps.herokuapp.com/",
      tech: "Socket.io, Javascript",
    },
    {
      title: "Snake-Game-AI",
      detail:
        "AI tries to play the SNAKE-Game making use of Reinforcement learning and Deep Neural Network",
      git:"https://github.com/Parth-Jain-2002/Snake-AI",
      live: "https://www.youtube.com/watch?v=4X_3YYGqXfM",
      tech: "Python, Machine learning",
    },
    {
      title: "Covid-Tracker",
      detail:
        "A tracker to track down Covid-19 cases, deathes and recoveries in all the countries of the world",
      git:"https://github.com/Parth-Jain-2002/Covid-Tracker",
      live: "https://covid19tracker-9c035.web.app/",
      tech: "ReactJS,MaterialUI,Disease API",
    },
    {
      title: "Whatsapp-Clone",
      detail:
        "This is a clone of Whatsapp. It has UI similiar to Whatsapp Web and has group chat functionality",
      git: "https://github.com/Parth-Jain-2002/WhatsappClone",
      live: "https://whatsapp-mern-672d9.web.app/",
      tech: "ReactJS,Firebase Hosting,MaterialUI",
    },
    {
      title: "Doof-Website",
      detail:
        "This is a website built for my Content Creator friend C.Blue. Amazing site for art and story lover. Go visit this beautiful site",
      live: "https://doof-3f715.web.app/",
      tech: "ReactJS,MaterialUI,Email-js",
    },
  ];
  return (
    <section id="projects" className="project">
      <div className="project__container">
        <div className="project__header">
          <h3>My Projects</h3>
        </div>
        <div className="project__content">
          <ProjectCard data={projects[0]} />
          <ProjectCard data={projects[1]} />
          <ProjectCard data={projects[2]} />
          <ProjectCard data={projects[3]} />
          <ProjectCard data={projects[4]} />
          <ProjectCard data={projects[5]} />
          <ProjectCard data={projects[6]} />
          <ProjectCard data={projects[7]} />
        </div>
      </div>
    </section>
  );
};

export default Project;
